<div class="card">
  <div class="flex flex-col gap-6 items-center w-full" *ngIf="ready">
    <div class="w-full">
      <button
        class="button-elevation p-2 rounded-full"
        (click)="goBackToStep()"
      >
        Torna allo step
      </button>
    </div>

    <div class="w-full shadow-medium p-4 rounded-3xl">
      <p class="text-2xl">Enigma</p>
      <app-dynamic-form
        #myForm
        [options]="form2Opts"
        [fields]="regConfig2"
        (resetData)="initializeForm()"
        (onFieldChangeEmitter)="onFormChanges($event)"
        (submit)="submit($event)"
      >
      </app-dynamic-form>

      <div>
        <p class="text-lg">Tipo domanda</p>
        <div
          class="flex justify-start items-center p-2 gap-6"
          style="max-width: 100%; overflow: scroll"
        >
          @for(questionType of questionTypes; track $index){
          <div
            (click)="changeQuestionType(questionType)"
            [class]="
              buttonClass +
              (selectedQuestionType == questionType
                ? ' bg-primary-500 text-black'
                : ' bg-white/10')
            "
          >
            <i-tabler
              [name]="questionTypeIcons[questionType]"
              style="width: 1.5rem"
            ></i-tabler>
            <p class="text-center">{{ questionTypeLabels[questionType] }}</p>
          </div>
          }
        </div>

        @switch (selectedQuestionType) { @case (questionTypes[0]) {
        <div @slideDownUp class="flex flex-col gap-2 p-2">
          <p>
            Risposta corretta:
            <span @slideDownUp class="font-medium text-primary-500">{{
              multipleChoiceConfig.options[
                multipleChoiceConfig.correctOptionIndex
              ] || "Non selezionata"
            }}</span>
          </p>
          <div class="flex justify-between items-center gap-4">
            <input
              type="text"
              (keyup.enter)="addChoice(optionInsertValue)"
              (ngModelChange)="validateData()"
              [(ngModel)]="optionInsertValue"
              class="e-input"
              placeholder="Inserisci il valore dell'opzione"
            />

            <button mat-icon-button (click)="addChoice(optionInsertValue)">
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <mat-selection-list
            #shoesList
            [multiple]="false"
            (selectionChange)="validateData()"
          >
            @for (option of multipleChoiceConfig.options; track $index) {
            <div class="flex justify-start items-center">
              <mat-list-option
                [value]="$index"
                (selectedChange)="
                  multipleChoiceConfig.correctOptionIndex = $index
                "
                [selected]="$index == multipleChoiceConfig.correctOptionIndex"
              >
                {{ option }}
              </mat-list-option>
              <button mat-icon-button (click)="deleteChoice($index)">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="icon icon-tabler icons-tabler-outline icon-tabler-trash"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M4 7l16 0" />
                  <path d="M10 11l0 6" />
                  <path d="M14 11l0 6" />
                  <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12" />
                  <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                </svg>
              </button>
            </div>
            }
          </mat-selection-list>

          @if(multipleChoiceConfig.options.length == 0){
          <p>Aggiungi un'opzione per continuare</p>
          }
        </div>
        } @case (questionTypes[1]) {
        <div @slideDownUp class="flex flex-col gap-2 p-2">
          <p>
            Risposta corretta:
            <span
              @slideDownUp
              class="font-medium {{
                truefalseConfig.correctAnswer
                  ? ' text-emerald-500'
                  : ' text-red-500'
              }}"
              >{{ truefalseConfig.correctAnswer ? "Vero" : "Falso" }}</span
            >
          </p>
          <div class="flex justify-start items-center gap-4 w-full">
            <div
              (click)="truefalseConfig.correctAnswer = true"
              [class]="
                buttonClass +
                (truefalseConfig.correctAnswer == true
                  ? ' bg-emerald-500 text-white '
                  : '')
              "
            >
              <i-tabler name="check" style="width: 1.5rem"></i-tabler>
              <p class="text-center">Vero</p>
            </div>

            <div
              (click)="truefalseConfig.correctAnswer = false"
              [class]="
                buttonClass +
                (truefalseConfig.correctAnswer == false
                  ? ' bg-red-500 text-white '
                  : '')
              "
            >
              <i-tabler name="x" style="width: 1.5rem"></i-tabler>
              <p class="text-center">Falso</p>
            </div>
          </div>
        </div>

        } @case (questionTypes[2]) {

        <div @slideDownUp class="flex flex-col gap-2 p-2">
          <p>Risposta corretta</p>
          <input
            type="text"
            mask="separator"
            thousandSeparator="."
            decimalMarker=","
            (ngModelChange)="validateData()"
            [(ngModel)]="numericConfig.correctNumber"
            class="e-input"
            placeholder="Valore numerico"
          />
        </div>
        } @case (questionTypes[3]) {

        <!-- <p @slideDownUp class="p-2">Lo sblocco avverrà dopo la scansione del QR Code</p> -->

        <div @slideDownUp class="p-4 rounded-3xl shadow-small w-fit"></div>
        } @case (questionTypes[4]) {

        <!-- <p @slideDownUp class="p-2">Lo sblocco avverrà dopo la scansione del QR Code</p> -->

        <div @slideDownUp class="p-4 rounded-3xl shadow-small w-fit"></div>
        } }
      </div>
    </div>

    @if(object){

    <div class="w-full shadow-medium p-4 rounded-3xl">
      <p class="text-2xl">Storie</p>
      <app-storie-enigmi
        [idEnigma]="object.id"
        [data]="object.stories"
      ></app-storie-enigmi>
    </div>
    }

    <app-edit-history [data]="editHistoryData"></app-edit-history>
  </div>
</div>
